import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createRoot} from 'react-dom/client';
//import {legacy_createStore} from 'redux';
// import {legacy_createStore as createStore} from 'redux'
// import  rootReducer  from './redux/combinedReducers'; 
// import { Provider } from 'react-redux';

//console.log(" red", rootReducer);
// const store=createStore(rootReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() ); // => create object to access store of states


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);


//const root = ReactDOM.createRoot(document.getElementById('root').requestFullscreen());
root.render(
  
  // <React.StrictMode>
 //  <Provider store={store}>
    <App />
  //</Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
/**
 * 
 * <Provider store={store}>
    <App />
  </Provider>,
 * 
 */